import { FilterFilled } from '@ant-design/icons';
import type { MouseEvent } from 'react';
import { useTheme } from 'styled-components';

import { Tooltip } from 'components/ui';
import { Theme } from 'utils/color/horizonTheme';

type ConditionalFilterIconProps = {
  filtered: boolean;
  disabled: boolean;
  disabledTooltip?: string;
};

export const ConditionalFilterIcon = ({
  filtered,
  disabled,
  disabledTooltip,
}: ConditionalFilterIconProps) => {
  const theme = useTheme();
  const handleDisabledInteraction = (event: MouseEvent<HTMLSpanElement>) => {
    if (disabled) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  const opacity = disabled ? 0.45 : theme.themeName === Theme.Dark && !filtered ? 0.45 : 1;

  const icon = (
    <span
      onClick={handleDisabledInteraction}
      onMouseDown={handleDisabledInteraction}
      style={{
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
      }}
    >
      <FilterFilled className={filtered ? 'ant-table-filter-trigger-container-open' : undefined} />
    </span>
  );

  if (disabled && disabledTooltip) {
    return <Tooltip title={disabledTooltip}>{icon}</Tooltip>;
  }

  return icon;
};
